module.exports = __webpack_public_path__ + "static/media/combyGlass.a68e112f.jpg";